import { render, staticRenderFns } from "./FormTextarea.vue?vue&type=template&id=24d7816e&scoped=true"
import script from "./FormTextarea.vue?vue&type=script&lang=ts"
export * from "./FormTextarea.vue?vue&type=script&lang=ts"
import style0 from "./FormTextarea.vue?vue&type=style&index=0&id=24d7816e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d7816e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24d7816e')) {
      api.createRecord('24d7816e', component.options)
    } else {
      api.reload('24d7816e', component.options)
    }
    module.hot.accept("./FormTextarea.vue?vue&type=template&id=24d7816e&scoped=true", function () {
      api.rerender('24d7816e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/FormTextarea.vue"
export default component.exports